import { render, staticRenderFns } from "./TeachinSectionList.vue?vue&type=template&id=ec7f3ea4&scoped=true&"
import script from "./TeachinSectionList.vue?vue&type=script&lang=js&"
export * from "./TeachinSectionList.vue?vue&type=script&lang=js&"
import style0 from "./TeachinSectionList.vue?vue&type=style&index=0&id=ec7f3ea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7f3ea4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
installComponents(component, {VBtn,VCard,VIcon,VItem,VItemGroup})
